import { CardModel, PileCardModel } from "../../interface/game";
import { PileAnnotationPolicy } from "./pile-annotation-policy";

export function annotatePileCards(
    policies: PileAnnotationPolicy[],
    pile: PileCardModel[], 
    cards: {[key: string]: CardModel}
): PileCardModel[] {
    let resultCardModel = pile;

    for (const policy of policies) {
        resultCardModel = policy(resultCardModel, cards);
    }

    return resultCardModel;
}